import { useEffect } from "react";

const SITE = "https://www.charlesmckuhn.com";
const DEFAULT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/7df89ba4-2e95-4b11-bc51-9873287ee9e6/images/2203eda037fc51894d00d4df1a217c78fd031b2720f43f936fe77a7ceb3935c8.jpeg";

// Imperatively upserts the existing <head> SEO tags (seeded in index.html)
// so each route has exactly ONE canonical/description/OG set — no duplicates —
// and restores the previous values on unmount.
export const Seo = ({ title, description, path = "/", image, type = "website" }) => {
  useEffect(() => {
    const url = `${SITE}${path}`;
    const img = image || DEFAULT_IMG;
    const snapshots = [];

    const upsertMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      const existed = !!el;
      const prev = el ? el.getAttribute("content") : null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
      snapshots.push(() => {
        if (existed) el.setAttribute("content", prev);
        else el.remove();
      });
    };

    const prevTitle = document.title;
    document.title = title;
    snapshots.push(() => (document.title = prevTitle));

    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:type", type);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    const canonExisted = !!canonical;
    const prevCanon = canonical ? canonical.getAttribute("href") : null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
    snapshots.push(() => {
      if (canonExisted) canonical.setAttribute("href", prevCanon);
      else canonical.remove();
    });

    return () => snapshots.forEach((restore) => restore());
  }, [title, description, path, image, type]);

  return null;
};
